import request from '@/services/request';
import store from '@/store';

export async function fetchRecentDonations(params = {}, fundraiserSlug = null, campaignId = null) {
  try {
    const orgId = store.state.orgId;
    const finalCampaignId = campaignId || store.state.campaign?.id || store.state.donation?.campaignId;

    if (!orgId || !finalCampaignId) {
      console.error('Missing required IDs:', {
        orgId,
        finalCampaignId,
        availableStoreData: { campaignState: store.state.campaign, donationState: store.state.donation }
      });
      throw new Error('Organization ID or Campaign ID not found');
    }

    // Build the endpoint URL with params in the URL like the pages version
    const baseUrl = `/public/recent-donations/${orgId}/${finalCampaignId}`;
    const urlWithFundraiser = fundraiserSlug ? `${baseUrl}/${fundraiserSlug}` : baseUrl;
    const url = `${urlWithFundraiser}?params=${encodeURIComponent(JSON.stringify(params))}`;

    const { data, error } = await request.get(url);

    if (error) {
      throw new Error(error.message || 'Failed to fetch recent donations');
    }

    return data;
  } catch (error) {
    console.error('Error fetching recent donations:', error);
    throw error;
  }
}
